var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-select-buttons',{attrs:{"items":_vm.items,"value":_vm.value,"size":_vm.size,"pc-size":_vm.pcSize,"error-messages":_vm.errorMessages},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }